import { useState } from "react";
import { Button } from "./ui/button";

export default function ArticleMatchCard({ match, preLeakDate }) {
  const [expanded, setExpanded] = useState(false);

  const isPreLeak =
    match.publish_date &&
    preLeakDate &&
    new Date(match.publish_date) < new Date(preLeakDate);

  const leakFlags = match.leak_flags || [];

  return (
    <div className="border p-4 rounded shadow bg-white mb-4">
      <div className="flex justify-between items-start">
        <div>
          <h2 className="text-lg font-semibold text-gray-900">
            {match.title || match.url}
          </h2>
          <p className="text-sm text-gray-500">
            Similarity: {(match.similarity * 100).toFixed(2)}%
          </p>

          {match.publication && (
            <p className="text-sm text-gray-700">
              <strong>Publication:</strong> {match.publication}
            </p>
          )}

          {match.persons && (
            <p className="text-sm text-gray-700">
              <strong>Journalist(s):</strong>{" "}
              {match.persons.replace(/;/g, ", ")}
            </p>
          )}

          {match.explanation && (
            <p className="text-sm text-gray-700 mt-1 italic">
              <strong className="not-italic">Explanation:</strong>{" "}
              {match.explanation}
            </p>
          )}

          {leakFlags.length > 0 && (
            <div className="mt-2 flex flex-wrap gap-2">
              {leakFlags.map((flag, i) => (
                <span
                  key={i}
                  className="bg-red-100 text-red-800 text-xs px-2 py-1 rounded-full border border-red-300"
                >
                  #{flag}
                </span>
              ))}
            </div>
          )}

          {isPreLeak && (
            <span className="inline-block mt-2 text-xs bg-yellow-100 text-yellow-800 px-2 py-1 rounded-full border border-yellow-300">
              Pre-Leak
            </span>
          )}
        </div>

        <Button size="sm" variant="outline" onClick={() => setExpanded(!expanded)}>
          {expanded ? "Hide" : "Details"}
        </Button>
      </div>

      {expanded && (
        <div className="mt-3 space-y-2 text-sm text-gray-800">
          <p>
            <strong>Summary:</strong> {match.summary}
          </p>
          {match.themes && <p><strong>Themes:</strong> {match.themes}</p>}
          {match.persons && <p><strong>Persons:</strong> {match.persons}</p>}
          {match.organizations && <p><strong>Organizations:</strong> {match.organizations}</p>}
          <a
            href={match.url}
            className="text-blue-600 underline"
            target="_blank"
            rel="noopener noreferrer"
          >
            View Full Article ↗
          </a>
        </div>
      )}
    </div>
  );
}
